import { styled } from "@vitality-ds/system";
import BaseIconButtonStyles from "./styles/BaseIconButton.styles";
export var BaseIconButton = styled("button", BaseIconButtonStyles);
export var BaseIconButtonLink = styled("a", BaseIconButtonStyles);